(function() {
    'use strict';

    /*
     * A module for handling login-related routes (e.g. /login and /oauthcallback).
     * Deals with user/access tokens.
     *
     */

    // Register all routes handled by this module
    angular.module('GorillaBoy.Login')
    .config(['$routeProvider', function($routeProvider) {
        var OAUTH_LAYOUT = './login/oauth2.html',
            NO_COOKIES_LAYOUT = './login/no_cookies.html',
            NOT_ACTIVE = './login/not_active.html';

        $routeProvider
        .when('/login', {
            templateUrl: OAUTH_LAYOUT,
            controller: 'LoginController',
            reloadOnSearch: false
        })
        .when('/oauth2callback', {
            templateUrl: OAUTH_LAYOUT,
            controller: 'OAuth2CallbackController',
            reloadOnSearch: false
        })
        .when('/invite', {
            templateUrl: OAUTH_LAYOUT,
            controller: 'InviteController'
        })
        .when('/no_cookies', {
            templateUrl: NO_COOKIES_LAYOUT,
            controller: 'LoginFailedController'
        })
        .when('/genericError', {
            templateUrl: './login/generic_error.html',
            controller: 'GenericErrorController'
        })
        .when('/not_active', {
            templateUrl: NOT_ACTIVE,
            controller: 'LoginFailedController'
        })
        .when('/site_not_exists_error', {
            templateUrl: './login/site_not_exists_error.html',
            controller: 'GenericErrorController'
        })
        .when('/authSuccess', {
            templateUrl: OAUTH_LAYOUT,
            controller: 'AuthSuccessController',
            reloadOnSearch: false
        })
        .otherwise({
            redirectTo: '/login'
        });

    }]);
}());